const namespace = {
  title: "Property value drivers",
  description:
    "These characteristics most positively impact the values of homes in this neighborhood.",
  noData:
    "Discover characteristics that influence home prices; this list details the factors that positively affect property values in a {{locationType}}.",
  locationType: {
    neighborhood: "neighborhood",
    location: "location",
  },
  valueDrivers: {
    bus_service_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Having bus services enhances connectivity and accessibility, making it more attractive to commuters and increasing the overall desirability of the {{locationType}}.",
      },
    },
    shops_and_services_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Having plenty of nearby shops and services that are easily accessible can increase the overall desirability of a {{locationType}}.",
      },
    },
    coffee_shop_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Nearby and easily accessible coffee shops can create a welcoming environment and a more desirable {{locationType}}.",
      },
    },
    clothing_and_accessory_store_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Many nearby clothing and accessory stores which are easily accessible can increase the overall desirability of a {{locationType}}.",
      },
    },
    common_needs_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easy access to basic amenities such as hardware stores, post offices, and convenience stores can improve the accessibility of services in a {{locationType}}.",
      },
    },
    department_store_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Nearby department stores that are easily accessible can increase the overall desirability of a {{locationType}}.",
      },
    },
    entertainment_venue_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Easily accessible entertainment venues can indicate a more vibrant and desirable {{locationType}}.",
      },
    },
    fitness_establishment_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Easily accessible fitness establishments such as gyms, yoga studios, and pools can create a more desirable {{locationType}}.",
      },
    },
    nightlife_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easy access to local centers of nightlife, such as bars, pubs, and comedy clubs, can indicate a more vibrant {{locationType}}.",
      },
    },
    pedestrian_oriented_street_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easily accessible commercial streets designed to be pedestrian-friendly can create a more desirable {{locationType}}.",
      },
    },
    rapid_transit_service_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Nearby rapid transit stations with frequent service can indicate a more accessible {{locationType}}.",
      },
    },
    restaurant_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Easily accessible and nearby restaurants can create a more desirable {{locationType}}.",
      },
    },
    specialty_grocery_store_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Nearby specialty grocery stores can indicate a more desirable {{locationType}}.",
      },
    },
    sports_facility_access: {
      tag: {
        high: "Many nearby",
      },
      qualifier: {
        high: "Nearby sports facilities such as soccer fields, running tracks, and ice rinks can create a more desirable {{locationType}}.",
      },
    },
    train_service_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Nearby train stations with frequent service can indicate a more accessible {{locationType}}.",
      },
    },
    nearest_highway_proximity: {
      tag: {
        high: "Great access",
        low: "Low density",
      },
      qualifier: {
        high: "Easy access to major highways can create a more accessible {{locationType}}.",
        low: "Few major highways nearby can create a quieter and more desirable {{locationType}}.",
      },
    },
    nearest_pharmacy_proximity: {
      tag: {
        high: "Available close",
      },
      qualifier: {
        high: "Easy access to a nearby pharmacy can indicate a more accessible {{locationType}}.",
      },
    },
    nearest_bicycle_share_station_proximity: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Nearby bicycle-sharing stations can lead to a more accessible {{locationType}}.",
      },
    },
    bicycle_path_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easily accessible bicycle paths can create a more accessible and desirable {{locationType}}.",
      },
    },
    bicycle_share_station_access: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Nearby bicycle-sharing stations can lead to a more accessible {{locationType}}.",
      },
    },
    nearest_park_area: {
      tag: {
        high: "Available close",
      },
      qualifier: {
        high: "Large nearby parks can create a more desirable {{locationType}}.",
      },
    },
    bicycle_infrastructure_quality: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "High-quality bicycle infrastructure can create a more accessible {{locationType}}.",
      },
    },
    high_schools: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easy access to nearby schools can create a more desirable {{locationType}}.",
      },
    },
    primary_schools: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easy access to nearby schools can create a more desirable {{locationType}}.",
      },
    },
    quiet: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Few sources of nearby noise can create a more desirable {{locationType}}.",
      },
    },
    daycares: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Easy access to nearby childcare can create a more desirable {{locationType}}.",
      },
    },
    parks: {
      tag: {
        high: "Great access",
      },
      qualifier: {
        high: "Plenty of nearby parks can create a more desirable {{locationType}} environment.",
      },
    },
  },
} as const;

export default namespace;
